export const CHAT_COPY = {
  failed: 'Not sent. Tap to try again.',
  discard: 'Discard',
  streamDown: 'Not live — checking for new messages every 30 s. Click to retry.',
  live: 'Live',
  connecting: 'Connecting…',
  listFailed: "Couldn't load Chat.",
  threadFailed: "Couldn't load messages. Tap to retry.",
  retry: 'Retry',
  dockNothingUnread: 'Nothing unread — switch to All',
  noConversations: "No conversations yet. A client's ops thread appears here when either side writes.",
  threadEmptyStaff: "Anything you send reaches this client's portal users.",
  composerHint: (count: number, client: string) => `Seen by ${count} client users at ${client}`,
  composerPlaceholder: 'Write a message',
  loadingOlder: 'Loading earlier messages',
  startConversationEmpty: 'No clients match',
  startConversationEmptyNone: 'No clients yet',
  startConversationFailed: "Couldn't open that conversation.",
  noConversationsAction: 'No conversations yet. Message a client to start one.',
  noBroadcasts: 'No broadcasts sent yet.',
  newBroadcast: 'New broadcast',
  newBroadcastHint: 'Every active portal user for the selected client receives this message.',
  newShiftBroadcastHint: 'Guards who have accepted the shift receive this as a push and in their Chat tab.',
  noBroadcastShifts:
    'No shifts with accepted guards are running or starting in the next 24 hours. Broadcast to a client instead.',
  guardNameUnavailable: 'Name unavailable',
  noShiftMatch: 'No shift matches that search.',
  shiftSearch: 'Search by site or shift',
  shiftsFailed: "Couldn't load shifts. Tap to retry.",
  shiftRunning: 'Running',
  shiftOvertime: 'Overtime',
  shiftStartsAt: (time: string) => `Starts ${time}`,
  guardOnDuty: 'On duty',
  pickAShift: 'Select a shift.',
  pickAGuard: 'Select at least one guard.',
  guardCount: (count: number) => `${count} ${count === 1 ? 'guard' : 'guards'}`,
  selectBroadcast: 'Select a broadcast to see who has read it.',
  noPermission: "Chat isn't enabled for your profile. Ask an administrator to add the Chat permission.",
  accessEnded: 'Your access to Chat has ended. Ask your administrator.',
  accessEndedAction: 'Back to Watch',
  notAvailable: "This conversation isn't available.",
  notAvailableAction: 'Back',
  attachmentFailed: 'Tap to reload',
  mentionPickerEmpty: 'No one else can be mentioned here',
  mentionDropped: (name: string) => `Not delivered to @${name} — not in this conversation`,
  deleteFailed: "Couldn't delete. Try again.",
  cannotPost: "You can't post in this conversation right now. You can still read new messages.",
  deleteConfirmTitle: 'Delete this message?',
  deleteConfirmBody:
    'Everyone in the conversation sees it was removed by the ops desk. The record is kept for audit.',
  deleteConfirmAction: 'Delete',
  deleteCancel: 'Cancel',
  sendWithoutIt: 'Send without it',
  transportFailed: 'Unable to reach the server. Please check your connection and try again.',
  broadcastsEmpty: 'No broadcasts sent yet.',
  reachFailed: "Couldn't check the audience.",
  rosterEmpty: 'No recipients.',

  newChat: 'New chat',
  newChatSearch: 'Search people and clients',
  newChatPeople: 'People',
  newChatClients: 'Clients',
  newChatEmpty: 'No one matches',
  newChatEmptyNone: 'No one to message yet',
  directoryFailed: "Couldn't load people. Tap to retry.",
  clientsFailed: "Couldn't load clients. Tap to retry.",
  startDirectFailed: "Couldn't open that conversation.",

  newGroup: 'New group',
  newGroupTitle: 'New group',
  groupNameLabel: 'Group name',
  groupNamePlaceholder: 'What is this group for?',
  groupPeopleLabel: 'People',
  groupCreateAction: 'Create group',
  groupCreateFailed: "Couldn't create the group.",
  groupNeedsName: 'Name the group so members know what it is for.',
  groupNeedsMembers: 'Add at least one person.',
  groupCapacity: (count: number) => `${count} of 50`,
  groupAtCapacity: 'This group is full. Groups can have up to 50 people.',

  groupMembers: 'Group members',
  groupAddPeople: 'Add people',
  groupAddFailed: "Couldn't add them.",
  groupAddDuplicate: "They're already in this group.",
  groupRemove: 'Remove',
  groupRemoveFailed: "Couldn't remove them.",
  groupRemoveNotFound: "They've already left this group.",
  groupRename: 'Rename',
  groupRenameFailed: "Couldn't rename the group.",
  groupLeave: 'Leave group',
  groupLeaveConfirmTitle: 'Leave this group?',
  groupLeaveConfirmBody: "You stop receiving its messages. You may need someone to add you back to rejoin.",
  groupLeaveAction: 'Leave',
  groupLeaveFailed: "Couldn't leave the group.",
  groupYou: 'You',

  directSubtitle: 'Direct message',
  groupSubtitle: (count: number) => (count === 1 ? '1 member' : `${count} members`),
  composerHintDirect: (name: string) => `Only you and ${name} see this`,
  composerHintGroup: 'Seen by everyone in this group',
  threadEmptyDirect: (name: string) => `This is the start of your conversation with ${name}.`,
  threadEmptyGroup: 'This is the start of this group. Anything you send reaches every member.',
  deleteConfirmBodyInternal:
    'Everyone in the conversation sees it was removed. The record is kept for audit.',

  noConversationsChat: 'No conversations yet. Start a chat with a colleague.',

  systemGroupCreated: (actor: string) => `${actor} created this group`,
  systemGroupRenamed: (actor: string, title: string) => `${actor} renamed this group to ${title}`,
  systemMemberAdded: (actor: string, target: string) => `${actor} added ${target}`,
  systemMemberRemoved: (actor: string, target: string) => `${actor} removed ${target}`,
  systemMemberLeft: (actor: string) => `${actor} left`,
} as const

export const DISPATCHER_CHIPS = [
  'On it, checking now',
  'Sending a guard now',
  'Noted, thanks',
  'Please call the ops desk',
] as const
